import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import messages from '../../messages';
import { Button } from '../../../components/Button';
import PageSectionHeader from '../../../components/PageSectionHeader';
import Textbox from '../../../components/Textbox';
import CurrencySelector from '../../../components/CurrencySelector';
import OptionsContainer from '../../../components/OptionsContainer';
import FlexBox from '../../../../../components/FlexBox';
import DatePicker from '../../../components/DatePicker/index';
import MySelect from '../../../../../components/MySelect';
import { checkDateOnly, required } from '../../../../../utils/validation/validator';
import { Validate, ErrorMessage } from '../../../../../components/Validation';
import Select from 'react-select';
import ExpenseForSelect from '../../../components/ExpenseForSelect';
import * as _ from 'lodash';

export class SpecifiedItems extends React.Component {
  onChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };

  onChangeAmount = (propertyName) => (event) => {
    const target = event.target;
    const regexNumber = /^(0*[1-9]\d*(\.\d{0,2})?|0+\.\d*[1-9]\d*)$/; // regex to check for number > 0
    let value = target.type === 'checkbox' ? target.checked : target.value;
    if (regexNumber.test(value)) {
      const item = { ...this.props.item, ...{ [propertyName]: value } };
      this.change(item);
    } else {
      value = '';
      const item = { ...this.props.item, ...{ [propertyName]: value } };
      this.change(item);
    }
  };

  onRemoveClick = () => {
    if (this.props.onRemove) {
      this.props.onRemove(this.props.item.id);
    }
  };

  onChangeResetReceived = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    item.fromWhom = '';
    item.howMuch = '';
    item.currencyExpensesClaimed = '';
    item.dateReimbursementReceived = '';
    this.change(item);
  };

  handleChangeInsureds = (selectedClaimFor) => {
    if (selectedClaimFor) {
      const item = { ...this.props.item, ...{ ['selectedClaimFor']: selectedClaimFor } };
      this.change(item);
    }
  };

  handleSelectedSpecifiedItems = (propertyName, index) => (event) => {
    let { item } = this.props;
    const { specifiedItems } = this.props;
    const expensesSelected = !!item.specifiedItemIds && typeof item.specifiedItemIds.toJS === 'function'
      ? item.specifiedItemIds.toJS()
      : item.specifiedItemIds || [];
    const listChecked = _.cloneDeep(expensesSelected);
    const specifiedItemId = specifiedItems[index].id;
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(specifiedItemId);
    } else {
      listChecked.splice(listChecked.indexOf(specifiedItemId), 1);
    }
    item = { ...this.props.item, ...{ [propertyName]: listChecked } };
    this.change(item);
  };

  handleDayChange = (propertyName) => (date) => {
    const localDate = removeTimeZoneFromDate(date);
    const item = { ...this.props.item, ...{ [propertyName]: localDate } };
    this.change(item);
  };

  handleSelectDepreciationType = (propertyName) => (value) => {
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };

  change = (item) => {
    if (this.props.onChange) {
      this.props.onChange(item);
    }
  };
  handleCurrencyChange = (propertyName) => (value) => {
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };

  render() {
    const {
      disabled,
      removable,
      validatorGroup,
      validationCounter,
      insuredsList,
      isClaimForFieldEnabled,
      item,
      depreciationTypes,
      specifiedItems,
      isCurrencyAUD,
      isCurrencyNZD,
    } = this.props;
    // const showDepreciationType = depreciationTypes.length > 0;
    const selectedClaimForList = !!item.selectedClaimFor && typeof item.selectedClaimFor.toJS === 'function'
      ? item.selectedClaimFor.toJS()
      : item.selectedClaimFor || [];
    return (
      <div className="expenses">
        <div className="row align-items-center">
          {!disabled &&
            removable && (
              <div className="form-group col-auto">
                <Button onClick={this.onRemoveClick}>Remove</Button>
              </div>
            )}
        </div>
        {isClaimForFieldEnabled === true &&
          <div className="row">
            <div className="form-group col-sm-6 col-md-6">
              <ExpenseForSelect
                validatorGroup={validatorGroup}
                validationCounter={validationCounter}
                defaultValue={selectedClaimForList}
                disabled={disabled}
                options={insuredsList}
                onChange={(v) => this.handleChangeInsureds(v)}
                value={selectedClaimForList}
                fieldName={messages.expenseFor}
                tooltipContent={messages.selectInsuredForExpense.defaultMessage}
                messages={messages}
              />
            </div>
            <div className="form-group col-sm-6 col-md-6">
            </div>
          </div>
        }
        <div className="row">
          <div className="form-group col-md-6 col-sm-6">
            <Validate
              name="dateOfIncident"
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required, checkDateOnly]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              defaultValue={item.dateOfExpenses}
              fieldName={messages.dateOfIncident}
            >
              <DatePicker
                disabled={disabled}
                name="dateOfIncident"
                type="text"
                onDayChange={this.handleDayChange('dateOfExpenses')}
                value={item.dateOfExpenses}
                placeholder="dd/mm/yyyy"
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.dateOfIncident}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className="form-group col-md-6 col-sm-6">
            <Validate
              name="dateOfPurchase"
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required, checkDateOnly]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              defaultValue={item.dateOfPurchase}
              fieldName={messages.dateOfPurchase}
            >
              <DatePicker
                disabled={disabled}
                name="dateOfPurchase"
                type="text"
                onDayChange={this.handleDayChange('dateOfPurchase')}
                value={item.dateOfPurchase}
                placeholder="dd/mm/yyyy"
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.dateOfPurchase}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-sm-12 col-md-12">
            <PageSectionHeader>
              <FormattedMessage {...messages.areYouClaimingForASpecifiedItem} />
            </PageSectionHeader>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-sm-1 col-md-1">
          </div>
          <div className="form-group col-sm-11 col-md-11">
            <div className="row">
              <div className="form-group col-sm-3 col-md-3">
                <PageSectionHeader>
                  <FormattedMessage {...messages.itemType} />
                </PageSectionHeader>
              </div>
              <div className="form-group col-sm-5 col-md-5" >
                <PageSectionHeader style={{ paddingLeft: '20px' }}>
                  <FormattedMessage {...messages.descriptionOfValuables} />
                </PageSectionHeader>
              </div>
              <div className="form-group col-sm-4 col-md-4">
                <PageSectionHeader>
                  {isCurrencyAUD ? (
                    <FormattedMessage {...messages.amountAUD} />
                  ) : (
                    <FormattedMessage {...messages.amountUSD} />
                  )}
                </PageSectionHeader>
              </div>
            </div>
          </div>
          {specifiedItems.map((specifiedItem, index) => (
            <div className="row" style={{ paddingBottom: '5px' }}>
              <div className="col-sm-1" style={{ paddingTop: '10px' }}>
                <input
                  type="checkbox"
                  value={specifiedItem.id}
                  name="specifiedItemIds"
                  checked={item.specifiedItemIds.includes(specifiedItem.id)}
                  onChange={this.handleSelectedSpecifiedItems('specifiedItemIds', index)}
                />
              </div>
              <div className="col-sm-10">
                <div className="row">
                  <div className="col-sm-4 form-control" style={{ border: '1px solid black' }}>
                    <input
                      disabled
                      name="descriptionText"
                      type="text"
                      value={specifiedItem.descriptionText}
                    />
                  </div>
                  <div className="col-sm-4 form-control" style={{ border: '1px solid black' }}>
                    <input
                      disabled
                      name="covered"
                      type="text"
                      value={specifiedItem.covered}
                    />
                  </div>
                  <div className="col-sm-4 form-control" style={{ border: '1px solid black' }}>
                    <input
                      disabled
                      name="amount"
                      type="text"
                      value={specifiedItem.amount}
                    />
                  </div>
                </div>
              </div>
              <div className="col-sm-1"></div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

SpecifiedItems.propTypes = {
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
  item: PropTypes.object,
  index: PropTypes.number,
  removable: PropTypes.bool,
  disabled: PropTypes.bool,
  validatorGroup: PropTypes.object,
  validationCounter: PropTypes.number,
  depreciationTypes: PropTypes.any,
  showDropdowns: PropTypes.bool,
  insuredsList: PropTypes.any,
  isClaimForFieldEnabled: PropTypes.bool,
  isCurrencyAUD: PropTypes.bool,
  isCurrencyNZD: PropTypes.bool,
  specifiedItems: PropTypes.any,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.SCTI.BaggageAndPersonalItems/components/SpecifiedItem/specifiedItems.js